<template>
  <!-- I haven't made any change to this template. This is only copy and paste from doc site. -->
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-xs-right">
            <importxlsx :noraw="true" :key="updatedKey" @onChange="importCsv"></importxlsx>
            <exportxlsx v-model="xlsxdata"></exportxlsx>
            <v-btn outline color="primary" @click="showAdvanceSearch"> Advance search </v-btn>
          </div>
        </v-flex>
        <v-flex xs6>
          <v-pagination
            @input="changepage"
            v-model="page"
            :length="pagelength"
            :total-visible="7"
          ></v-pagination>
        </v-flex>
        <v-flex xs6>
          <div class="form-control">
            <div style="position: relative">
              <input
                @keyup.enter="getBranch"
                class="mb-0"
                placeholder="Search"
                v-model="search.name"
                type="text"
              />
              <v-btn
                @click="getBranch"
                :loading="loading"
                style="position: absolute; right: 5px; top: 5px"
                class="ma-0"
                icon
                ><v-icon color="primary">search</v-icon></v-btn
              >
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr @click="showDetail(props.item)" style="cursor: pointer">
            <td>{{ props.item.branch_name }}</td>
            <td>{{ props.item.location_group }}</td>
            <td>{{ props.item.place }}</td>
            <td>{{ props.item.building }}</td>
            <td>{{ props.item.province }}</td>
            <td class="text-xs-right">
              <toggle-button
                :value="props.item.branch_status"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="onChangeBranchStatus(props.item.id)"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="detaildialog" width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="detaildialog = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div><BranchDetail v-if="detaildata" :detaildata="detaildata"></BranchDetail></div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="advancesearch" persistent width="500px">
      <v-card class="pa-3">
        <div class="text-xs-right">
          <v-btn @click="advancesearch = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="form-control">
          <label>Location group (Name) </label>
          <input v-model="search.location_group" type="text" />
        </div>
        <div class="form-control">
          <label>สถานที่</label>
          <input v-model="search.place" type="text" />
        </div>
        <div class="form-control">
          <label>จังหวัด</label>
          <input v-model="search.province" type="text" />
        </div>
        <div>
          <v-btn @click="getBranch" block color="primary" depressed>ค้นหา</v-btn>
          <v-btn @click="clearSearch" block color="grey" outline>Clear search</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import BranchDetail from './BranchDetail.vue'
import api from '@/api'
export default {
  components: {
    exportxlsx,
    importxlsx,
    ToggleButton,
    BranchDetail
  },
  data: () => ({
    loading: false,
    currentShow: '',
    limit: 10,
    page: 1,
    updatedKey: 1,
    pagetmp: 1,
    pagetotal: 0,
    offset: 0,
    detaildialog: false,
    detaildata: '',
    search: {
      name: '',
      location_group: '',
      place: '',
      province: ''
    },
    headers: [
      {
        text: 'Name',
        align: 'center',
        // sortable: false,
        value: 'branch_name'
      },
      {
        text: 'Location Group (Name)',
        align: 'center',
        value: 'location_group'
      },
      { text: 'สถานที่', align: 'center', value: 'place' },
      { text: 'ห้าง/อาคาร', align: 'center', value: 'building' },
      { text: 'จังหวัด', align: 'center', value: 'province' },
      { text: 'Branch Status', align: 'center', value: 'status', sortable: false }
    ],
    items: [],
    advancesearch: false
  }),

  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    },
    xlsxdata() {
      var json = this.items.map((el) => {
        return {
          'Location Group (Name)': el.location_group,
          'จังหวัด(Th)': el.province,
          'Short Name': el.short_name,
          Address: el.address,
          Tel: el.tel,
          'Open Time': el.open_times,
          'Close Time': el.close_times,
          'Google Maps': el.google_maps,
          latitude: el.latitude,
          longitude: el.longitude,
          สถานที่ใกล้เคียง: el.nearby_place,
          'ห้าง/อาคาร': el.building,
          'สถานที่(Th)': el.place,
          ภาค: el.zone,
          ชนิดร้าน: el.type_store,
          BU: el.bu,
          ID: el.branch_id,
          Name: el.branch_name,
          'Branch Status': el.status ? 'Open' : 'Close'
        }
      })
      return json
    }
  },
  mounted() {
    this.getBranch()
  },
  methods: {
    showAdvanceSearch() {
      this.advancesearch = true
    },
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.getBranch()
      }
    },
    clearSearch() {
      for (const [key, value] of Object.entries(this.search)) {
        if (value) {
          Object.assign(data, { [key]: '' })
        }
      }
      this.advancesearch = false
      this.getBranch()
    },
    getBranch() {
      var vm = this
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      var data = {
        limit: this.limit,
        offset: this.offset,
        pageid: this.selectedBot.pageid
      }
      for (const [key, value] of Object.entries(this.search)) {
        if (value) {
          Object.assign(data, { [key]: value })
        }
      }
      this.loading = true
      api.com7getbranchs(data, (err, response) => {
        this.pagetotal = parseInt(response.total)
        this.loading = false
        this.items = response.data
      })
    },
    showDetail(item) {
      this.detaildata = item
      this.detaildialog = true
    },
    onChangeBranchStatus(id) {
      var index = this.items.findIndex((el) => el.id == id)
      this.items[index].branch_status = !this.items[index].branch_status
      var data = {
        pageid: this.selectedBot.pageid,
        branchStatus: this.items[index].branch_status, // boolean
        branchId: id
      }
      api.com7updateBranchStatus(data, (err, response) => {})

      // console.log(this.items[index].branch_status)
    },
    importCsv(file) {
      this.updatedKey++
      var data = {
        pageid: this.selectedBot.pageid,
        files: file[0]
        // .map((el) => {
        //   return {
        //     'Location Group (Name)': el['Location Group (Name)'] ? el['Location Group (Name)'] : '',
        //     'จังหวัด(Th)': el['จังหวัด(Th)'] ? el['จังหวัด(Th)'] : '',
        //     'Short Name': el['Short Name'] ? el['Short Name'] : '',
        //     Address: el['Address'] ? el['Address'] : '',
        //     Tel: el['Tel'] ? el['Tel'] : '',
        //     'Open Time': el['Open Time'] ? el['Open Time'] : '',
        //     'Close Time': el['Close Time'] ? el['Close Time'] : '',
        //     'Google Maps': el['Google Maps'] ? el['Google Maps'] : '',
        //     latitude: el['latitude'] ? el['latitude'] : '',
        //     longitude: el['longitude'] ? el['longitude'] : '',
        //     สถานที่ใกล้เคียง: el['สถานที่ใกล้เคียง'] ? el['สถานที่ใกล้เคียง'] : '',
        //     'ห้าง/อาคาร': el['ห้าง/อาคาร'] ? el['ห้าง/อาคาร'] : '',
        //     'สถานที่(Th)': el['สถานที่(Th)'] ? el['สถานที่(Th)'] : '',
        //     ภาค: el['ภาค'] ? el['ภาค'] : '',
        //     ชนิดร้าน: el['ชนิดร้าน'] ? el['ชนิดร้าน'] : '',
        //     BU: el['BU'] ? el['BU'] : '',
        //     ID: el['ID'] ? el['ID'] : '',
        //     Name: el['Name'] ? el['Name'] : '',
        //     Branch: el['Branch'] ? el['Branch'] : '',
        //     Status: el['Status'] ? el['Status'] : '',
        //     1: el['1'] ? el['1'] : '',
        //   }
        // }),
      }

      api.com7importbranchs(data, (err, response) => {
        if (response.responsecode == 200) {
          this.$swal.fire({
            type: 'success',
            text: 'สำเร็จ'
          })
          this.getBranch()
        }
      })
    },
    deleteItem(item) {
      const index = this.items.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket2/productandbranch/Branch.vue